import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Scrollbar } from 'components';
import { Checkbox } from '../Checkbox';
import ArrowDown from './arrow-down.svg';

class DropdownMultiForFilter extends PureComponent {
  constructor(props) {
    super(props);

    const { initMessage } = props;

    this.state = {
      listOpen: false,
      headerTitle: initMessage,
      searchValue: '',
      // withoutData: false,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const result = {};
    const { initMessage } = nextProps;

    if (JSON.stringify(nextProps.value) !== JSON.stringify(prevState.value)) {
      const itemsArr = [];
      const titleArr = [];
      const helpArr = [...nextProps.value];
      if (nextProps.list.length > 0) {
        helpArr.map((item) => {
          const newObjectItem = (nextProps.list || []).find(
            (listItem) => listItem.value === item || +listItem.value === +item,
          );
          if (newObjectItem !== undefined) {
            itemsArr.push(newObjectItem);
          }
        });
        itemsArr.length &&
          itemsArr.map((item) => titleArr.push(item.title || ''));

        result.value = nextProps.value;
        result.headerTitle = titleArr.length
          ? titleArr.join(', ')
          : initMessage;
      }
    }

    return result;
  }

  componentDidUpdate(prevProps) {
    const { listOpen } = this.state;

    setTimeout(() => {
      if (listOpen) {
        window.addEventListener('click', this.close);
      } else {
        window.removeEventListener('click', this.close);
      }
    }, 0);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.close);
  }

  close = () => {
    this.setState({
      listOpen: false,
    });
  };

  toggleList = (displayedList) => {
    if (this.props.disabled || displayedList.length === 0) {
      return;
    }

    this.setState((prevState) => ({
      listOpen: !prevState.listOpen,
    }));
  };

  selectItem = (item) => {
    const { initMessage, value, list } = this.props;
    const { headerTitle } = this.state;
    const helpArr = [...value];

    let titleArr = headerTitle.split(';');

    titleArr.length === 1 &&
      (titleArr[0] === initMessage || titleArr[0] === '') &&
      titleArr.splice(0, 1);

    if (+item.value === 0) {
      if (helpArr.includes(item.value)) {
        for (let i = 0; i < helpArr.length; i++) {
          helpArr.splice(0, helpArr.length);
          titleArr.splice(0, titleArr.length);
        }
      } else {
        helpArr.splice(0, helpArr.length);
        titleArr.splice(0, titleArr.length);
        helpArr.push(item.value);
        titleArr.push(item.title);
        for (let i = 0; i < list.length; i++) {
          helpArr.push(list[i].value);
          titleArr.push(list[i].title);
        }
      }
    } else {
      if (helpArr.includes(item.value)) {
        for (let i = 0; i < helpArr.length; i++) {
          if (helpArr.length === list.length + 1) {
            helpArr.splice(0, 1);
            titleArr.splice(0, 1);
          }
          if (item.value === helpArr[i]) {
            helpArr.splice(i, 1);
            titleArr.splice(i, 1);
          }
        }
      } else {
        helpArr.push(item.value);
        titleArr.push(item.title);
      }
    }

    titleArr.length === 0 && titleArr.push(initMessage);

    const savedValue = helpArr;

    this.setState({
      headerTitle: titleArr.join('; '),
      value: savedValue,
    });

    this.props.onChange(savedValue);
  };

  render() {
    const { list, label, disabled, rowsCount, value, name, showAllOption } =
      this.props;
    const { listOpen, headerTitle, searchValue } = this.state;

    let displayedList = searchValue
      ? list.filter(
          (listItem) =>
            listItem.title.toUpperCase().indexOf(searchValue.toUpperCase()) !==
            -1,
        )
      : list;

    if (!searchValue) {
      displayedList = [...displayedList];
    }

    const height =
      displayedList.length >= rowsCount
        ? (rowsCount + 1) * 40
        : (displayedList.length + 1) * 40;
    const allValue = { title: 'All', value: 0 };

    return (
      <div className="dd-wrapper" data-testid={`dropdown-${name}`}>
        <div
          className={classnames('dd-header', {
            _disabled: disabled || displayedList.length === 0,
          })}
          onClick={() => this.toggleList(displayedList)}
        >
          {label && <div className="dd-header-label">{label}</div>}
          <div className="dd-header-title multi-title">{headerTitle}</div>
          <ArrowDown
            style={{ minWidth: '12px' }}
            className={listOpen ? 'arrow-down' : ''}
          />
        </div>
        {listOpen && (
          <div
            style={{ height: `${height}px`, paddingBottom: '5px' }}
            className="dd-list drop-list"
            onClick={(e) => e.stopPropagation()}
          >
            <Scrollbar>
              <ul style={{ width: '100%' }}>
                {showAllOption && (
                  <li
                    className="multi-for-filter-li"
                    data-testid={`dropdown-item-${name}-${allValue.value}`}
                    key={allValue.value}
                  >
                    <Checkbox
                      name={allValue.value}
                      label={allValue.title}
                      isCheckedBox={value.includes(allValue.value)}
                      addComponentClass={'multiCheckbox'}
                      onChange={() => this.selectItem(allValue)}
                      conversely
                    />
                  </li>
                )}
                {displayedList.map((item, index) => (
                  <li
                    data-testid={`dropdown-item-${name}-${item.value}`}
                    key={index}
                  >
                    <Checkbox
                      name={item.value}
                      label={item.title}
                      labelClass={'filter-checkbox-class'}
                      isCheckedBox={
                        value.includes(item.value) && !item.disabled
                      }
                      addComponentClass={'multiCheckbox'}
                      isDisabledBox={item.disabled}
                      onChange={() => this.selectItem(item)}
                      conversely
                    />
                  </li>
                ))}
              </ul>
            </Scrollbar>
          </div>
        )}
      </div>
    );
  }
}

DropdownMultiForFilter.propTypes = {
  initMessage: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
  list: PropTypes.array,
  disabled: PropTypes.bool,
  search: PropTypes.bool,
  rowsCount: PropTypes.number,
  showCheckIcon: PropTypes.bool,
  showAllOption: PropTypes.bool,
};

DropdownMultiForFilter.defaultProps = {
  initMessage: '',
  onChange: (e) => {},
  value: '',
  list: [],
  disabled: false,
  search: false,
  rowsCount: 6,
  showCheckIcon: false,
  showAllOption: false,
};

export default DropdownMultiForFilter;
